import React from 'react';
import {Col, Container, Row} from 'react-bootstrap';

function Laverage(props) {
    return (
        <div className="laverage_section p-100">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={12} lg={12} xl={10} xxl={10} className="m-auto text-center">
                        <h2>Leverage Our Proven Process For Building Feature-Rich Mobile Application in Denver For You!</h2>
                        <p>Our professional mobile app developers in Denver streamline their activities to meet the deadlines, and deliver the end-product on time. You can now enhance efficiency and effectiveness by streamlining your core operations. Our solutions empower seamless processes, allowing you to focus on growth and innovation with confidence. Have a look at our quality-enriched mobile app development process:</p>
                    </Col>
                    <Col xs={12} md={12} lg={12} xl={12} xxl={11} className="m-auto">
                        <div className="process_listing">
                            <div className="process_item">
                                <div className="number">01</div>
                                <h6>Ideation</h6>
                                <p>Conduct a thorough research to pen down the necessary features for the application.</p>
                            </div>
                            <div className="process_item">
                                <div className="number">02</div>
                                <h6>Design</h6>
                                <p>Initiate with the UI/UX designing of the application for the clients.</p>
                            </div>
                            <div className="process_item">
                                <div className="number">03</div>
                                <h6>Development</h6>
                                <p>Our professional app developers in Denver start off with quality-enriched app development.</p>
                            </div>
                            <div className="process_item">
                                <div className="number">04</div>
                                <h6>Quality Assurance</h6>
                                <p>Testing the application, ensuring no bugs remain unsolved.</p>
                            </div>
                            <div className="process_item">
                                <div className="number">05</div>
                                <h6>Maintenance & Support</h6>
                                <p>Solving the issues in the application, post-delivery; if any</p>
                            </div>

                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Laverage;